import { useState } from "react";
import _ from "lodash";
import { Divider } from "../components/UI/divider";
import { Subheading } from "../components/UI/heading";
import { Input } from "../components/UI/input";
import { Text } from "../components/UI/text";

export default function UserSettings() {
  const FIELDS = [
    {name: "Tap #", selectable: false},
    {name: "Name", selectable: false},
    {name: "Qty", selectable: false},
    {name: "Votes", selectable: true},
    {name: "Group", selectable: true},
    {name: "Style", selectable: true},
    {name: "Stored In", selectable: true},
    {name: "Producer", selectable: true},
    {name: "Category", selectable: true},
    {name: "Beverage", selectable: true},
    {name: "ABV", selectable: true},
    {name: "Keg Type", selectable: true},
    {name: "Coupler", selectable: true},
    {name: "Keg Size", selectable: true},
    {name: "% Full / Oz", selectable: true},
    {name: "ETC", selectable: true},
    {name: "Date Put On", selectable: true},
    {name: "Date Queued", selectable: true},
    {name: "Date Added", selectable: true},
    {name: "Do Not Tap", selectable: true},
    {name: "Restricted Replacement", selectable: true},
    {name: "Serve After", selectable: true},
    {name: "Can Replace", selectable: true},
    {name: "Distributor", selectable: true},
    {name: "Current Event or HH", selectable: true},
    {name: "Notes", selectable: true}
  ];
  const [selectedFields, setSelectedFields] = useState(_.filter(FIELDS, f => f.selectable));

  function toggleSelection(field) {
    if (_.some(selectedFields, sf => sf.name === field.name)) {
      setSelectedFields(
        _.reject(selectedFields, sf => sf.name === field.name));
    } else {
      setSelectedFields([...selectedFields, field]);
    }
  }

  return (
    <div className="ms-12">
      <h2 className="text-3xl text-orange-700 font-bold m-3">Preferences</h2>
      <Divider className="my-6" />
      <div className="ms-6">
        <div className="grid md:grid-cols-12 grid-cols-3 mb-4 gap-4">
          <div className="col-span-2">
            <label>First Name</label>
            <Input placeholder="Enter First Name" />
          </div>
          <div className="col-span-2">
            <label>Last Name</label>
            <Input placeholder="Enter Last Name" />
          </div>
          <div className="col-span-3">
            <label>Email</label>
            <Input placeholder="Enter Email" />
          </div>
        </div>
        <Text>
          Select fields of interest to display. (These selections will be applied to all screens wherever you log in.)
        </Text>
        <div className="md:columns-5 columns-1">
        {_.map(FIELDS, f => (<div className="mb-2">
            <input 
              type="checkbox"
              className="text-3xl"
              disabled={!f.selectable}
              checked={_.some(selectedFields, sf => sf.name === f.name)}
              onChange={() => {
              if (f.selectable)
                toggleSelection(f);
            }} /> {f.name}
          </div>))}
        </div>
      </div>
    </div>
  );
}